import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LcDropDown from '../../../components/Generic/LcDropDown';
import LcIcon from '../../../components/Generic/LcIcon';
import LcIconLink from '../../../components/Generic/LcIconLink';
import LcLoading from '../../../components/Generic/LcLoading';
import LcTooltip from '../../../components/Generic/LcTooltip';
import { WorkView } from '../../../models/WorkView';
import WorkService from '../../../services/WorkService/WorkService';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import CancelWork from './CancelWork';
import CloseWork from './CloseWork';
import EditWork from './EditWork';
import NewWork from './NewWork';
import PauseWork from './PauseWork';
import PlayWork from './PlayWork';
import TransferWork from './TransferWork';
import { Selection } from '../../../models/Selection';
import LcInfiniteTable from '../../../components/Data/LcInfiniteTable';
import "./index.css";
import StatusColorDisplay from '../../../components/Generic/StatusColorDisplay';
import SolicitationAttendantService from '../../../services/SolicitationAttendantService/SolicitationAttendantService';
import AproveWork from './AproveWork';
import NewWorkMultiple from './NewWorkMultiple';
import UserService from '../../../services/HeyHoUserService/HeyHoUserService';

interface PropsWorkList {
    solicitation: any;
    refreshParentAction?: Function,
    handleRefreshData: Function,
    setLastWorkCompleted?: Function,
    getUpdatedSolicitation: Function
    aproverworks: Function
    reloadWorks: boolean
    changeReloadWorks?: Function
}

const WorkList: React.FC<PropsWorkList> = (props) => {
    const solicitationAttendantService: SolicitationAttendantService = new SolicitationAttendantService(props);
    const workService: WorkService = new WorkService(props);
    const userService: UserService = new UserService(props);
    const user = useSelector<RootState, UserState>(state => state.user);
    const dispatch = useDispatch();
    const [worksList, setWorksList] = useState<WorkView[]>([]);
    const [worksLinkedList, setWorksLinkedList] = useState<WorkView[]>([]);
    const [selectedRow, setSelectedRow] = useState<WorkView>();
    const [showModalWork, setShowModalWork] = useState<boolean>(false);
    const [type, setType] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [workSelectionList, setWorkSelectionList] = useState<Selection[]>([]);
    const [filteredWorksList, setFilteredWorksList] = useState<WorkView[]>([]);
    const [flagParms, setFlagParams] = useState<boolean>(true)
    const [newAprovallWork, setNewAprovallWork] = useState<WorkView>()
    const [workTypeMultiple, SetWorkTypeMultiple] = useState<any>();
    const [teamManagerList, setTeamManagerList] = useState<any[]>([]);

    const templateDefault: Selection = {
        label: "",
        text: "",
        fields: [{
            name: "",
            value: ""
        }]
    };

    useEffect(() => {
        if (props.solicitation) {
            retrieveData();
            // linkedSolicitations()
        }
    }, []);

    const getManagerByWorkTeamList = async (workListLocal: any[]) => {
        try {
            const workTeamList = workListLocal.map((work: any) => work.idWorkTeam);
            const response = await userService.GetWorkTeamManagerByWorkTeamList(workTeamList);

            var _list: any[] = [];

            workListLocal.map((work: any) => {
                var workTeamList: any = response.data[work.idWorkTeam];
                var listaRetorno = workTeamList.filter((x: any) => x === user.id);
                if (listaRetorno.length > 0) {
                    _list.push(work.id);
                }
            })

            setTeamManagerList(_list);
        }
        catch (error) {
            debugger
        }
    }

    const linkedSolicitations = async () => {
        var list = await solicitationAttendantService.GetLinkedSolicitation(props.solicitation.id);
        let activeWorks = list.filter(work => work.workStatus !== 7 && work.workStatus !== 8 && work.workStatus !== 6)
        if (activeWorks) {
            activeWorks.map(async i => {
                var list = await workService.getWorkViewbySolicitation(i.id);
                const openList = list.filter((x: WorkView) => x.idStatus !== 6 && x.idStatus !== 7 && x.idStatus !== 8)
                    .sort((a: WorkView, b: WorkView) => moment(a.startDate) > moment(b.startDate) ? 1 : -1);

                if (openList.length > 0) setWorksLinkedList([...openList]);
            })
        }
    }

    useEffect(() => {
        if (props.reloadWorks) {
            retrieveData();
            props.changeReloadWorks && props.changeReloadWorks();
        }
    }, [props.reloadWorks])

    const retrieveData = async () => {
        setLoading(true);
        let queryParam = window.location.search.split('type=')
        let idWork = window.location.search.split('idWork=')

        try {
            var list = await workService.getWorkViewbySolicitation(props.solicitation.id);
            list = list.filter((x: any) => x.disabled === 0);

            const openList = list.filter((x: WorkView) => x.idStatus !== 6 && x.idStatus !== 7 && x.idStatus !== 8)
                .sort((a: WorkView, b: WorkView) => moment(a.startDate) > moment(b.startDate) ? 1 : -1);
            const closedList = list.filter((x: WorkView) => x.idStatus === 6 || x.idStatus === 7 || x.idStatus === 8)
                .sort((a: WorkView, b: WorkView) => moment(a.endDate) < moment(b.endDate) ? 1 : -1);

            const aproverToWork = list.filter((x: WorkView) => x.idStatus === 14)
            aproverToWork.length > 0 ? props.aproverworks(true) : props.aproverworks(false)
            let mixedList = sortList(list);
            setWorksList(mixedList);
            setFilteredWorksList(mixedList);

            getManagerByWorkTeamList(mixedList);

            if (queryParam && idWork && flagParms) {
                workParams(parseInt(idWork[1]), parseInt(queryParam[1]), openList)
            }

            const lastWorkCompleted = closedList.filter(x => x.idStatus === 7);
            if (lastWorkCompleted.length !== 0 && props.setLastWorkCompleted) props.setLastWorkCompleted(lastWorkCompleted[0]);

            props.handleRefreshData(list, "works");
        }
        catch (e) {
            debugger;
        }

        setLoading(false);
    }

    const sortList = (worklist: WorkView[]): WorkView[] => {
        let listWithoutStartDate = worklist.filter(work => work.startDate === null && work.idStatus !== 6);
        let listWithoutStartDateCancel = worklist.filter(work => work.startDate === null && work.idStatus === 6);
        let listwithStartDate = worklist.filter(work => work.startDate !== null);

        let sortListWithoutStartDate = listWithoutStartDate.sort((a: WorkView, b: WorkView) => new Date(a.registrationDate).getTime() < new Date(b.registrationDate).getTime() ? 1 : -1);
        let sortListwithStartDate = listwithStartDate.sort((a: WorkView, b: WorkView) => new Date(a.startDate).getTime() < new Date(b.startDate).getTime() ? 1 : -1);
        return [...sortListWithoutStartDate, ...sortListwithStartDate, ...listWithoutStartDateCancel];
    }

    const onChangeSelectionWorks = (selection: any) => {
        if (selection.fields[0].value === "mais") {
            let filtered: WorkView[] = [];

            workSelectionList.map(workSelection => {
                let temp = worksList.find(x => x.id.toString() === workSelection.fields[0].value);

                if (temp != undefined) filtered.push(temp);
            })

            setFilteredWorksList(filtered);
        }
        else {
            const busca = selection.fields[0].value;

            const filtered = worksList.filter((x: WorkView) => x.id.toString().toLowerCase() === busca)
            setFilteredWorksList(filtered);
        }
    }

    const workParams = (idWork: number, type: number, workList: WorkView[]) => {
        setType(type)
        let work = workList.filter(work => work.id === idWork)
        workList.length > 0 && setSelectedRow(work[0])
        setShowModalWork(true);
        setFlagParams(false)
    }

    const [search, setSearch] = useState<string>("");
    const getSearch = (search: string) => {
        setSearch(search);
    }

    useEffect(() => {
        if (search !== "") {
            let workSelectionList: Selection[] = [];

            const worksListFiltered = worksList.filter((x: WorkView) => x.subject.includes(search));

            worksListFiltered.map((work: any) => {
                let workSelectionList_ = templateDefault;

                if (work.description === null) {
                    work.description = "";
                }

                const detailsLenght = work.description.length;

                const details = (detailsLenght <= 300) ? work.description : work.description.substring(0, 300) + " (...)";

                workSelectionList_ = {
                    label: "> " + work.id + " - " + work.subject + " - " + details,
                    text: work.subject,
                    fields: [{
                        name: work.subject,
                        value: work.id.toString()
                    }]
                }

                workSelectionList.push(workSelectionList_);
            })

            setWorkSelectionList(workSelectionList);
        }
        else {
            setWorkSelectionList([]);
            setFilteredWorksList(worksList);
        }
    }, [search]);

    const checkNewWorkDisabled = () => {
        let objectNewWork: any = undefined;

        if (props.solicitation.idStatus === 6 || props.solicitation.idStatus === 7 || props.solicitation.idStatus === 8) {
            objectNewWork = {
                title: 'Novo trabalho',
                icon: 'ppi ppi-plus',
                tooltip: 'Novo trabalho',
                iconDisabled: {
                    color: "#B5B7C6",
                    tooltip: "Não é possivel a criação de novos trabalhos com o status da solictação atual",
                    disabled: true,
                },
            }
        }
        else {
            objectNewWork = {
                title: 'Novo trabalho',
                icon: 'ppi ppi-plus',
                tooltip: 'Novo trabalho',
                func: () => {
                    setType(1);
                    setShowModalWork(true);
                }
            }
        }

        return objectNewWork;
    }

    const functionGeneric = [
        checkNewWorkDisabled(),
        {
            title: '',
            icon: 'ppi ppi-divider-vertical',
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "",
                disabled: true,
            },
            tooltip: '',
            func: () => {
            }
        },
        {
            title: 'Filtro',
            icon: 'ppi ppi-search',
            isFilter: true,
            isFilterCampo: {
                contents: workSelectionList.slice(0, 7),
                onChange: onChangeSelectionWorks,
                onChangePesquisa: getSearch,
            }
        },
        {
            title: '',
            icon: 'ppi ppi-divider-vertical',
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "",
                disabled: true,
            },
            tooltip: '',
            func: () => {
            }
        },
        {
            title: 'Atualizar trabalhos',
            icon: 'ppi ppi-refresh',
            tooltip: 'Atualizar trabalhos',
            func: () => {
                retrieveData();
            }
        },
        {
            title: '',
            icon: 'ppi ppi-divider-vertical',
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "",
                disabled: true,
            },
            tooltip: '',
            func: () => {
            }
        },
    ];

    const functionsRow = [
        {
            label: 'Iniciar',
            hidden: false,
            disabled: false,
            type: 0,
            func: (row: any) => {
                setType(0);
                setSelectedRow(row);
                setShowModalWork(true);
            },
        },
        {
            label: 'Editar',
            hidden: false,
            disabled: false,
            type: 6,
            func: (row: any) => {
                setType(6);
                setSelectedRow(row);
                setShowModalWork(true);
            },
        },
        {
            label: 'Terminar',
            hidden: false,
            disabled: false,
            type: 4,
            func: (row: any) => {
                setType(4);
                setSelectedRow(row);
                setShowModalWork(true);
            },
        },
        {
            label: 'Pausar',
            hidden: false,
            disabled: false,
            type: 3,
            func: (row: any) => {
                setType(3);
                setSelectedRow(row);
                setShowModalWork(true);
            },
        },
        // {
        //     label: 'Transferir',
        //     func: (row: any) => {
        //         setType(2);
        //         setSelectedRow(row);
        //         setShowModalWork(true);
        //     }, hidden: false, disabled: false, type: 2
        // },
        {
            label: 'Cancelar',
            hidden: false,
            disabled: false,
            type: 5,
            func: (row: any) => {
                setType(5);
                setSelectedRow(row);
                setShowModalWork(true);
            },
        }
    ];

    const dateTimeNow = new Date();
    const momentDateTimeNow = moment(dateTimeNow.toISOString());

    const handleRowClick = (row: any) => {
        setSelectedRow(row);
    }

    const [columnId, setColumnId] = useState<number>(-1);

    const rowClick = {
        rowPointer: true,
        rowFunction: handleRowClick,
        rowSelected: selectedRow,
        rowColumn: setColumnId
    }

    useEffect(() => {
        if (columnId !== -1 && columnId !== 4) {
            setType(6);
            setShowModalWork(true);
            setColumnId(-1);
        }
    }, [columnId]);



    const columns = [
        {
            field: 'subject',
            headerName: 'Assunto',
            width: '30%',
        },
        {
            field: 'startDate',
            headerName: 'Início',
            width: '10%',
            renderCell: (row: any) => {
                if (!row.startDate) {
                    return;
                }

                const time = new Date(row.startDate).toLocaleTimeString().slice(0, -3);
                const data = (momentDateTimeNow.format("YYYY-MM-DD") !== moment(row.startDate).format("YYYY-MM-DD"))
                    ? moment(row.startDate).fromNow()
                    : time;

                return <span> {data} </span>;
            }
        },
        {
            field: 'endDate',
            headerName: 'Término',
            width: '10%',
            renderCell: (row: any) => {
                if (!row.endDate) {
                    return;
                }

                const time = new Date(row.endDate).toLocaleTimeString().slice(0, -3);
                const data = (momentDateTimeNow.format("YYYY-MM-DD") !== moment(row.endDate).format("YYYY-MM-DD"))
                    ? moment(row.endDate).fromNow()
                    : time;

                var dataFull = moment(row.endDate).format("YYYY-MM-DD HH:mm");

                return <LcTooltip content={dataFull} > <span> {data} </span> </LcTooltip>;
            }
        },
        {
            field: 'idStatus',
            headerName: 'Status',
            width: '20%',
            renderCell: (row: any) => {
                return <StatusColorDisplay row={row} type={"work"} />
            }
        },
        {
            field: '',
            headerName: '',
            width: '25%',
            overflow: "visible",
            renderCell: (row: any) => {
                var showDots = false;
                functionsRow.map((f, i) => {
                    var enableButton = false;
                    enableButton = (row.idStatus === 1 || row.idStatus === 3) && (f.type === 0 || f.type === 5);

                    if (!enableButton) enableButton = (row.idStatus === 5 || row.idStatus === 11 || row.idStatus === 12 || row.idStatus === 13) && (f.type === 0 || f.type === 5);
                    if (!enableButton) enableButton = (row.idStatus === 2) && (f.type === 5 || f.type === 2 || f.type === 3 || f.type === 4 || f.type === 6);

                    if (enableButton) {
                        showDots = true;
                    }
                });

                return (
                    <div className="topbar">
                        <div className="functionsx"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "center"
                            }}
                        >
                            {
                                (row.idStatus === 1 || row.idStatus === 3) &&
                                <>
                                    {
                                        (row.idUser === user.id || row.idUser === null)
                                            ? <>
                                                <LcIconLink icon={"ppi ppi-play-circle"} size={'big'} onClick={() => { setType(0); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Iniciar trabalho"} />
                                                <LcIconLink icon={"ppi ppi-switch-horizontal"} size={'big'} onClick={() => { setType(2); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Transferir trabalho"} />
                                                <LcIconLink icon={"ppi ppi-x"} onClick={() => { setType(5); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Cancelar trabalho"} />
                                            </>
                                            : <LcIconLink icon={"ppi ppi-switch-horizontal"} size={'big'} onClick={() => { setType(2); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Transferir trabalho"} />
                                    }
                                </>
                            }
                            {
                                row.idStatus === 2 &&
                                <>
                                    {
                                        row.idUser === user.id &&
                                        <LcIconLink icon={"ppi ppi-check-circle"} onClick={() => { setType(4); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Terminar trabalho"} />
                                    }
                                    <LcIconLink icon={"ppi ppi-switch-horizontal"} size={'big'} onClick={() => { setType(2); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Transferir trabalho"} />
                                </>
                            }

                            {
                                (row.idStatus === 5 || row.idStatus === 11 || row.idStatus === 12 || row.idStatus === 13) &&
                                <>
                                    {
                                        (row.idUser === user.id)
                                            ? <>
                                                <LcIconLink icon={"ppi ppi-play-circle"} onClick={() => { setType(0); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Iniciar trabalho"} />
                                                <LcIconLink icon={"ppi ppi-switch-horizontal"} size={'big'} onClick={() => { setType(2); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Transferir trabalho"} />
                                            </>
                                            : <LcIconLink icon={"ppi ppi-switch-horizontal"} size={'big'} onClick={() => { setType(2); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Transferir trabalho"} />
                                    }
                                </>
                            }
                            {
                                row.idStatus === 14 &&
                                <>
                                    {
                                        user.approver === 1 && (row.idUser === user.id || row.idUser === null)
                                            ? <>
                                                {/* <LcIconLink icon={"ppi ppi-check-circle"} onClick={() => { setType(7); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Aprovar trabalho"} /> */}
                                                {/* <LcIconLink icon={"ppi ppi-x"} onClick={() => { setType(8); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Reprovar trabalho"} /> */}
                                                <LcIconLink icon={"ppi ppi-thumb-up"} onClick={() => { setType(7); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Aprovar trabalho"} />
                                                <LcIconLink icon={"ppi ppi-thumb-down"} onClick={() => { setType(8); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Reprovar trabalho"} />
                                                {
                                                    teamManagerList && teamManagerList.length > 0 && teamManagerList.includes(row.id) &&
                                                    <LcIconLink icon={"ppi ppi-x"} onClick={() => { setType(5); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Cancelar trabalho"} />
                                                }
                                            </>
                                            : <>
                                                <LcIcon icon={"ppi ppi-thumb-up"} tooltip={"Não liberado para aprovar"} disabled />
                                                <LcIcon icon={"ppi ppi-thumb-down"} tooltip={"Não liberado para reprovar"} disabled />
                                                {
                                                    teamManagerList && teamManagerList.length > 0 && teamManagerList.includes(row.id) &&
                                                    <LcIconLink icon={"ppi ppi-x"} onClick={() => { setType(5); setSelectedRow(row); setShowModalWork(true); }} tooltip={"Cancelar trabalho"} />
                                                }
                                            </>
                                    }
                                </>
                            }
                            {
                                (row.idStatus === 2 || row.idStatus === 5 || row.idStatus === 11 || row.idStatus === 12 || row.idStatus === 13) && row.idUser === user.id &&
                                <LcDropDown element={<LcIconLink icon="ppi ppi-dots-vertical" size="big" tooltip={"Mais ações"} />}>
                                    {
                                        functionsRow.map((f, i) => {
                                            if (!f.hidden) {
                                                let disabled = (f.disabled) || false;

                                                var enableButton = false;

                                                enableButton = (row.idStatus === 1 || row.idStatus === 3) && (f.type === 0 || f.type === 5);
                                                if (!enableButton) enableButton = (row.idStatus === 2) && (f.type === 5 || f.type === 2 || f.type === 3 || f.type === 4);
                                                if (!enableButton) enableButton = (row.idStatus === 11 || row.idStatus === 12 || row.idStatus === 13) && (f.type === 0 || f.type === 3 || f.type === 5);
                                                if (!enableButton) enableButton = (row.idStatus === 5) && (f.type === 0 || f.type === 5);

                                                if (enableButton) {
                                                    return (
                                                        <div
                                                            key={i}
                                                            className={`item${disabled ? ' disabled' : ''}`}
                                                            onClick={() => { !disabled && f.func(row); }}> {f.label} </div>
                                                    );
                                                }
                                            }
                                        })
                                    }
                                </LcDropDown>
                            }
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'nameUser',
            headerName: 'Atendente/Equipe',
            width: '25%',
            renderCell: (row: any) => {

                return (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            alignItems: "center",
                        }}
                    >
                        <LcIcon icon={(row.nameUser === null) ? "ppi ppi-clock" : "ppi ppi-user"} size="small" color={(row.nameUser === null) ? "#898DA6" : "#141B4D"} />
                        <div style={{ display: "flex", flexDirection: "column", marginBottom: "5px" }}>
                            {
                                row.nameUser != null &&
                                <span style={{ marginTop: "4px", fontSize: "14px" }}> {row.nameUser} </span>
                            }
                            <span style={{ marginTop: "4px", fontSize: "11px" }}>  {row.nameWorkTeam}</span>
                        </div>
                    </div>

                );
            }
        }
    ];

    const handleClose = async (value: boolean, work: any) => {
        setShowModalWork(false);

        if (value && (work === undefined || work.approval === 0)) {
            props.getUpdatedSolicitation();
            await retrieveData();
        }
    }

    useEffect(() => {
        if (newAprovallWork) {
            setType(1);
            setShowModalWork(true);
        }
    }, [newAprovallWork]);

    useEffect(() => {
        if (workTypeMultiple) {
            setType(9);
            setShowModalWork(true);
        }
    }, [workTypeMultiple]);

    useEffect(() => {
        dispatch({ type: 'PREF_OPENED_MODAL_WORK', payload: showModalWork });
    }, [showModalWork]);

    return (
        <>
            <LcLoading loading={loading} label={"Carregando..."}>
                {
                    filteredWorksList &&
                    <div
                        children={
                            <LcInfiniteTable
                                functionGeneric={functionGeneric}
                                rows={filteredWorksList}
                                size={worksList.length}
                                columns={columns}
                                loadMore={() => { }}
                                rowClick={rowClick}
                                workSelection={true}
                            />
                        }
                    />
                }
                {
                    type === 1 &&
                    <NewWork
                        solicitation={props.solicitation}
                        onCloseEvent={handleClose}
                        open={type === 1 && showModalWork}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                        aprovallWork={newAprovallWork}
                    />
                }
                {
                    (type === 2 || type === 10) && selectedRow &&
                    <TransferWork
                        solicitation={props.solicitation}
                        work={selectedRow}
                        onCloseEvent={handleClose}
                        open={(type === 2 || type === 10) && showModalWork}
                        type={type}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                    />
                }
                {
                    type === 3 && selectedRow &&
                    <PauseWork
                        solicitation={props.solicitation}
                        work={selectedRow}
                        onCloseEvent={handleClose}
                        open={type === 3 && showModalWork}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                    />
                }
                {
                    type === 4 && selectedRow &&
                    <CloseWork
                        solicitation={props.solicitation}
                        work={selectedRow}
                        onCloseEvent={handleClose}
                        open={type === 4 && showModalWork}
                        // linkedSolicitations={worksLinkedList}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                        workAprovall={setNewAprovallWork}
                        workTypeMultiple={SetWorkTypeMultiple}
                    />
                }
                {
                    type === 5 && selectedRow &&
                    <CancelWork
                        solicitation={props.solicitation}
                        work={selectedRow}
                        onCloseEvent={handleClose}
                        open={type === 5 && showModalWork}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                    />
                }
                {
                    type === 6 && selectedRow &&
                    <EditWork
                        solicitation={props.solicitation}
                        work={selectedRow}
                        onCloseEvent={handleClose}
                        open={type === 6 && showModalWork}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                    />
                }
                {
                    (type === 7 || type === 8) && selectedRow &&
                    <AproveWork
                        solicitation={props.solicitation}
                        work={selectedRow}
                        onCloseEvent={handleClose}
                        open={(type === 7 || type === 8) && showModalWork}
                        type={type}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                    />
                }
                {
                    type === 9 && selectedRow &&
                    <NewWorkMultiple
                        solicitation={props.solicitation}
                        work={selectedRow}
                        workTypeMultiple={workTypeMultiple}
                        onCloseEvent={handleClose}
                        open={type === 9 && showModalWork}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                    />
                }
                {
                    type === 0 && selectedRow &&
                    <PlayWork
                        solicitation={props.solicitation}
                        work={selectedRow}
                        onCloseEvent={handleClose}
                        open={type === 0 && showModalWork}
                        content={''}
                        confirmMessage={''}
                        abortMessage={''}
                    />
                }
            </LcLoading>
        </>
    );
};

export default WorkList;